"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skeletonPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const skeletonPropDefs = {
    loading: { type: 'boolean', default: true },
    ...index_js_1.widthPropDefs,
    ...index_js_1.heightPropDefs,
};
exports.skeletonPropDefs = skeletonPropDefs;
//# sourceMappingURL=skeleton.props.js.map